import { useQuery } from '@tanstack/react-query'
import apiClient from '../services/apiClient'

interface AuthState {
    isAdmin: boolean
    isMember: boolean
    isCoach: boolean
    adminData: any
    memberData: any
    coachData: any
    isLoading: boolean
    error: any
}

export function useAuthCheck(): AuthState {
    const { data, isLoading, error } = useQuery({
        queryKey: ['auth-check'],
        queryFn: () => apiClient.get('/users/check-auth').then((res) => res.data),
        retry: false,
        refetchOnWindowFocus: false,
        staleTime: 24 * 60 * 60 * 1000, // 1 jour
    })
    return {
        isAdmin: data?.isAdmin || false,
        isMember: data?.isMember || false,
        isCoach: data?.isCoach || false,
        adminData: data?.adminData || null,
        memberData: data?.memberData || null,
        coachData: data?.coachData || null,
        isLoading,
        error,
    }
}
